var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'rockiot-chartist rockiot-chartist-' + _vm.$attrs.serial,style:('background:' + _vm.$attrs.chartBackground)})
}
var staticRenderFns = []

export { render, staticRenderFns }